const headers = {
	'X-Forwarded-Proto': 'https',
	'Access-Control-Allow-Origin': '*',
};

export default headers;
